/* 🤖 this file was generated by svg-to-ts */
import { SiriusFlag } from './sirius-flags.model';
import { siriusFlagCs } from './sirius-flag_cs.icon';
import { siriusFlagDaDk } from './sirius-flag_da-DK.icon';
import { siriusFlagDeDe } from './sirius-flag_de-DE.icon';
import { siriusFlagEnGb } from './sirius-flag_en-GB.icon';
import { siriusFlagEnUs } from './sirius-flag_en-US.icon';
import { siriusFlagEsEs } from './sirius-flag_es-ES.icon';
import { siriusFlagEsMx } from './sirius-flag_es-MX.icon';
import { siriusFlagFi } from './sirius-flag_fi.icon';
import { siriusFlagFrFr } from './sirius-flag_fr-FR.icon';
import { siriusFlagHu } from './sirius-flag_hu.icon';
import { siriusFlagItIt } from './sirius-flag_it-IT.icon';
import { siriusFlagJa } from './sirius-flag_ja.icon';
import { siriusFlagKo } from './sirius-flag_ko.icon';
import { siriusFlagNb } from './sirius-flag_nb.icon';
import { siriusFlagNlBe } from './sirius-flag_nl-BE.icon';
import { siriusFlagPl } from './sirius-flag_pl.icon';
import { siriusFlagPtBr } from './sirius-flag_pt-BR.icon';
import { siriusFlagPtPt } from './sirius-flag_pt-PT.icon';
import { siriusFlagRo } from './sirius-flag_ro.icon';
import { siriusFlagSe } from './sirius-flag_se.icon';
import { siriusFlagTh } from './sirius-flag_th.icon';
import { siriusFlagTr } from './sirius-flag_tr.icon';
import { siriusFlagVi } from './sirius-flag_vi.icon';
import { siriusFlagZhHans } from './sirius-flag_zh-Hans.icon';
import { siriusFlagZhHant } from './sirius-flag_zh-Hant.icon';
export const completeFlagSet: SiriusFlag[] = [
  siriusFlagCs as SiriusFlag,
  siriusFlagDaDk as SiriusFlag,
  siriusFlagDeDe as SiriusFlag,
  siriusFlagEnGb as SiriusFlag,
  siriusFlagEnUs as SiriusFlag,
  siriusFlagEsEs as SiriusFlag,
  siriusFlagEsMx as SiriusFlag,
  siriusFlagFi as SiriusFlag,
  siriusFlagFrFr as SiriusFlag,
  siriusFlagHu as SiriusFlag,
  siriusFlagItIt as SiriusFlag,
  siriusFlagJa as SiriusFlag,
  siriusFlagKo as SiriusFlag,
  siriusFlagNb as SiriusFlag,
  siriusFlagNlBe as SiriusFlag,
  siriusFlagPl as SiriusFlag,
  siriusFlagPtBr as SiriusFlag,
  siriusFlagPtPt as SiriusFlag,
  siriusFlagRo as SiriusFlag,
  siriusFlagSe as SiriusFlag,
  siriusFlagTh as SiriusFlag,
  siriusFlagTr as SiriusFlag,
  siriusFlagVi as SiriusFlag,
  siriusFlagZhHans as SiriusFlag,
  siriusFlagZhHant as SiriusFlag
];
